import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Zap, Shield, Database, HardDrive, Bot, Download, Layers, Cloud, ShieldCheck } from 'lucide-react';
import { useData } from '../context/DataContext';

const Home = () => {
  const { scripts, analytics, trackPageView } = useData();

  useEffect(() => {
    trackPageView('home');
  }, [trackPageView]);

  const categories = [
    {
      name: 'Performance',
      path: '/performance',
      icon: Zap,
      description: 'Optimize SQL Server performance with monitoring and tuning scripts',
      color: '#28a745',
      scriptCount: scripts.filter(s => s.category === 'Performance').length
    },
    {
      name: 'Security',
      path: '/security',
      icon: Shield,
      description: 'Secure your SQL Server with comprehensive security audit scripts',
      color: '#f093fb',
      scriptCount: scripts.filter(s => s.category === 'Security').length
    },
    {
      name: 'High Availability',
      path: '/high-availability',
      icon: Database,
      description: 'Ensure business continuity with HA monitoring and maintenance scripts',
      color: '#4facfe',
      scriptCount: scripts.filter(s => s.category === 'High Availability').length
    },
    {
      name: 'Backup & Recovery',
      path: '/backup-recovery',
      icon: HardDrive,
      description: 'Comprehensive backup strategies and disaster recovery solutions',
      color: '#17a2b8',
      scriptCount: scripts.filter(s => s.category === 'Backup & Recovery').length
    },
    {
      name: 'Automation',
      path: '/automation',
      icon: Bot,
      description: 'Automate routine DBA tasks with PowerShell and T-SQL scripts',
      color: '#6f42c1',
      scriptCount: scripts.filter(s => s.category === 'Automation').length
    },
    {
      name: 'Installation',
      path: '/installation',
      icon: Download,
      description: 'SQL Server installation guides and configuration scripts',
      color: '#fd7e14',
      scriptCount: scripts.filter(s => s.category === 'Installation').length
    },
    {
      name: 'Architecture & Config',
      path: '/architecture',
      icon: Layers,
      description: 'Database design patterns and configuration best practices',
      color: '#20c997',
      scriptCount: scripts.filter(s => s.category === 'Architecture').length
    },
    {
      name: 'Azure SQL',
      path: '/azure-sql',
      icon: Cloud,
      description: 'Cloud database management and Azure SQL optimization',
      color: '#0078d4',
      scriptCount: scripts.filter(s => s.category === 'Azure SQL').length
    },
    {
      name: 'Miscellaneous',
      path: '/maintenance',
      icon: ShieldCheck,
      description: 'Maintenance procedures and general DBA utilities',
      color: '#dc3545',
      scriptCount: scripts.filter(s => s.category === 'Miscellaneous').length
    }
  ];



  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">MSSQLDBATeam.com</h1>
        <p className="page-description">
          Your comprehensive SQL Server DBA resource hub featuring production-ready scripts, 
          expert articles, and best practices for performance optimization, security hardening, 
          and high availability solutions. Everything you need for professional database administration.
        </p>
      </div>



      <div className="section-grid">
        {categories.map(category => {
          const Icon = category.icon;
          return (
            <Link key={category.name} to={category.path} className="section-card" style={{ textDecoration: 'none' }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                <Icon size={32} color={category.color} style={{ marginRight: '15px' }} />
                <div>
                  <h3 className="section-title">{category.name}</h3>
                  <span style={{ color: '#6c757d', fontSize: '0.9rem' }}>
                    {category.scriptCount} scripts available
                  </span>
                </div>
              </div>
              <p className="section-description">{category.description}</p>
            </Link>
          );
        })}
      </div>

      <div style={{ background: 'white', padding: '30px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.07)', marginTop: '40px' }}>
        <h2 style={{ marginBottom: '20px', color: '#2c3e50' }}>Featured Scripts</h2>
        <div className="script-list">
          {scripts.slice(0, 5).map(script => (
            <div key={script.id} className="script-item">
              <Link to={`/script/${script.id}`} className="script-link">
                {script.title}
              </Link>
              <div style={{ fontSize: '0.9rem', color: '#6c757d', marginTop: '5px' }}>
                {script.category} - {script.subcategory}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home;